var _path, _circle, _circle2, _circle3, _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcoEpgDisplay = function SvgIcoEpgDisplay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F9F3F7",
    d: "M16 19a1 1 0 1 1 0 2H8a1 1 0 1 1 0-2zm5-16a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2zM3 15h18V5H3z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 13,
    r: 1,
    fill: "#F9F3F7"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 10,
    r: 1,
    fill: "#F9F3F7"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 7,
    r: 1,
    fill: "#F9F3F7"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 2,
    x: 7,
    y: 6,
    fill: "#F9F3F7",
    rx: 1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 2,
    x: 7,
    y: 9,
    fill: "#F9F3F7",
    rx: 1
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 2,
    x: 7,
    y: 12,
    fill: "#F9F3F7",
    rx: 1
  })));
};
export default SvgIcoEpgDisplay;